import request from '@/axios/request.js'

//可领取优惠券列表
export function getCoupons(params) {
  return request({
    url: '/api/ec/coupons',
    method: 'get',
    params
  })
}

//可领取优惠券列表
export function getCouponDetail(id) {
  return request({
    url: "/api/ec/coupons/getCouponDetail/"+id,
    method: 'get'
  })
}

//获取我的优惠卷列表
export function getMyCouponList(params) {
  return request({
    url: "/api/ec/coupons/getMyCouponList",
    method: 'get',
    params
  })
}

//领取优惠券
export function receiveCoupon(id) {
  return request({
    url: "/api/ec/coupons/receive/"+id,
    method: 'get'
  })
}
//优惠券订单获取
export function getCouponByCart(cartIds) {
  return request({
    url: "/api/ec/coupons/order/"+cartIds,
    method: 'get'
  })
}

//兑换优惠券
export function exchangeCoupon(couponCode) {
  return request({
    url: "/api/ec/coupons/exchangeCoupon/"+couponCode,
    method: 'get'
  })
}
